module.exports = __webpack_public_path__ + "img/facebook.43a87eb5.svg";